module.exports = __webpack_public_path__ + "img/map.41185d0a.jpg";